import { ladeGemischt, verwirfAppJePruefung } from '../persistence/pruefungsEinstellungen';
import { getStore } from '../persistence/store';
import { useAppStore } from './useAppStore';

/**
 * Alle Quellen neu mischen und in den Store übernehmen — beim Start, nach einem gescannten
 * oder verworfenen Code, beim Prüfungswechsel und nach dem Herunterladen einer Prüfung.
 *
 * Vorher fallen die App-Änderungen einer anderen Prüfung weg (Entscheidung des Nutzers,
 * 2026-10-10): sie gelten nur, solange ihre Prüfung ausgewählt ist. Die Prüfung kommt aus dem
 * Store, nicht aus der Gerätezeile — die wird nebenher geschrieben und kann kurz nachhinken.
 */
export async function mischeEinstellungenNeu(): Promise<void> {
  const { clientId, examId } = useAppStore.getState();
  const store = getStore();
  await verwirfAppJePruefung(store, clientId, examId);
  useAppStore.getState().uebernehmeEinstellungen(await ladeGemischt(store, clientId, examId));
}
